import Vue from 'vue';
import Instructions from '@/components/pages/InstructionsPage/Instructions.vue'

Vue.component('instructions', Instructions);
